import React, { useState, useRef } from "react";
import "./App.css";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";

function App() {
  const [qrValue, setQrValue] = useState("https://shop.jms.rocks");
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [bgColor, setBgColor] = useState("#ffffff");
  const [fgColor, setFgColor] = useState("#f48fb1");
  const [borderColor, setBorderColor] = useState("#f48fb1");
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQrValue(event.target.value);
  };

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDownload = async () => {
    if (qrCodeRef.current) {
      try {
        const dataUrl = await toPng(qrCodeRef.current);
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = "qr-code.png";
        link.click();
      } catch (error) {
        console.error("Failed to download QR code:", error);
      }
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>QR Code Generator</h1>
        <input
          type="text"
          placeholder="Enter text for QR code"
          value={qrValue}
          onChange={handleInputChange}
          className="input-text"
        />
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          className="input-file"
        />
        <div className="color-picker-container">
          <div className="color-picker">
            <input
              type="color"
              value={bgColor}
              onChange={(e) => setBgColor(e.target.value)}
              className="color-input"
            />
            <span className="color-label">BG</span>
          </div>
          <div className="color-picker">
            <input
              type="color"
              value={fgColor}
              onChange={(e) => setFgColor(e.target.value)}
              className="color-input"
            />
            <span className="color-label">FG</span>
          </div>
          <div className="color-picker">
            <input
              type="color"
              value={borderColor}
              onChange={(e) => setBorderColor(e.target.value)}
              className="color-input"
            />
            <span className="color-label">Border</span>
          </div>
        </div>
        <div
          className="qr-code-container"
          ref={qrCodeRef}
          style={{ border: `5px solid ${borderColor}` }}
        >
          <QRCode value={qrValue} bgColor={bgColor} fgColor={fgColor} />
          {uploadedImage && (
            <img src={uploadedImage} alt="Uploaded" className="uploaded-image" />
          )}
        </div>
        <button onClick={handleDownload} className="download-button">
          Download QR Code
        </button>
      </header>
    </div>
  );
}

export default App;